module.exports = __webpack_public_path__ + "img/logo-green-light.dce492ad.svg";